export enum EntityType {
  DEPOT = "DEPOT",
  KEEPSAKE = "KEEPSAKE",
}
export enum EntityTypeValue {
  DEPOT = 1,
  KEEPSAKE = 2,
}
